namespace Bookhus.Widgets {

    interface IDealListProps {
        dealType: DealType;
        validateAllowBooking: boolean;
        validationMessage: string;
        pageSize: number;
        culture: string;
    }

    export enum DealType {
        Deal = 0,
        Cancellation = 1,
        Highlighted = 2,
        Random = 3
    }

    type LoaderJQuery = JQuery & {
        displayLoader(): void;
        hideLoader(): void;
    };

    type DealListJQuery = JQuery & {
        displayEmptyMessage(): void;
        emptyList(): void;
        addItem(deal: IDeal): void;
    };

    type DealControlJQuery = JQuery & {
        renderControls(totalItems: number): void;
    };



    const INSTANCE_NAME = 'deal_list_instance';

    export class DealList implements IContentFilter {

        private props: IDealListProps;
        private container: JQuery;
        private loader: LoaderJQuery;
        private dealList: DealListJQuery;
        private dealControl: DealControlJQuery;


        private currentPage = 1;
        private filter: ISearchCridentials;
        private deals: IDeal[];

        private constructor(container: JQuery, props: IDealListProps) {
            this.container = container;
            this.props = props;
            this.buildContainer();
        }

        private buildContainer() {
            this.container.addClass('position-relative');
            this.container.css('min-height', '600px');

            this.loader = this.buildLoader();
            this.loader.appendTo(this.container);

            this.dealList = this.buildDealList();
            this.dealList.appendTo(this.container);

            this.dealControl = this.buildDealControl();
            this.dealControl.appendTo(this.container);
        }

        private buildLoader(): LoaderJQuery {
            var $container = $(`
                <div class="deal-loader" style="display: none; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); height: 80px; width: 80px; background-color: rgba(0, 0, 0, 0.5); border-radius: 0.25rem; z-index: 1;">
                    <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                        <i class="fas fa-spinner fa-spin" style="font-size: 40px; color: white;"></i>
                    </div>
                </div>
            `) as LoaderJQuery;

            $container.displayLoader = () => {
                $container.css('display', 'block');
            };

            $container.hideLoader = () => {
                $container.css('display', 'none');
            };

            return $container;
        }

        private buildDealList(): DealListJQuery {
            var $container = $(`
                <div class="deal-list position-relative row row-cols-1 row-cols-md-2 row-cols-lg-3">

                </div>
            `) as DealListJQuery;

            $container.displayEmptyMessage = () => {
                $container.html(`
                    <div class="col-12 col-md-12 col-lg-12 col-xl-12 text-center">
                        ${(this.props.dealType == DealType.Deal ? (window as any).Bookhus.Localization.Standard.UI.Widgets.DealList.NoRecentOffersFound : (window as any).Bookhus.Localization.Standard.UI.Widgets.DealList.NoRecentCancellationFound)}
                    </div>
                `);
            };

            $container.emptyList = () => {
                $container.html('');
            };

            $container.addItem = (deal) => {
                var protocol = (window.location.protocol || "http:") + '//';
                var url = "";
                if (deal.house.domain != null && deal.house.domain.length > 0) {
                    url = protocol + deal.house.domain;
                }

                var startDate = new Date(deal.fromdateRfc1123);
                var endDate = new Date(deal.todateRfc1123);

                var { priceString, showPrice } = deal
                if (!showPrice) {
                    priceString = '';
                }
                else if (this.props.dealType == DealType.Deal) {
                    priceString = (window as any).Bookhus.Localization.Standard.UI.GeneralText.Savings  + ' ' + priceString;
                }

                var $item = $(`
                    <div class="col mb-4">
                        <div class="card h-100 p-3 d-flex flex-column">
                            <div class="borderBottom pb-2 flex-fill">
                                <div class="row ">
                                    <div class="col-md-4">
                                        <div class="cardImg mb-3">
                                            <img src="${url}/houseimage/${deal.house.imageId}/150" class="img-fluid rounded" alt="">
                                        </div>
                                    </div>
                                    <div class="col-md-8 d-flex flex-column">
                                        <div class="d-flex borderBottom justify-content-between">
                                            <div class="flex-fill pb-2">
                                                <h5 class="mb-1 font-weight-bold">
                                                    ${deal.house.title}
                                                </h5>
                                                ${deal.house.address ? `<h6 class="subText mb-1">${deal.house.address.streetname}, ${deal.house.address.zipcode} ${deal.house.address.city}</h6>` : '&nbsp;'}
                                            </div>
                                        </div>
                                        <div class="h5 font-weight-bold text-secondary mb-0">
											${priceString}
										</div>
                                    </div>
                                </div>
                            </div>                            
                            <div class="borderBottom">
                                <h6 class="darkText font-weight-bold pullUp">
                                    <span class="whiteBg pr-4"></span>
                                </h6>
                                <div class="chekInOut row font-size-1 pb-2">
                                    <div class="col-sm-6">
                                        <div class="text-secondary pb-1 font-weight-bold">${(window as any).Bookhus.Localization.Standard.UI.GeneralText.Arrival}</div>
                                        <div class="d-flex justify-content-between  flex-wrap">
                                            <span class="pb-1"><i class="fa fa-sun-o mr-1"></i> ${startDate.toString("dddd")}</span>
                                            <span class="pb-1"><i class="fa fa-calendar mr-1"></i> ${startDate.toString("d")}</span>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="text-secondary pb-1 font-weight-bold">${(window as any).Bookhus.Localization.Standard.UI.GeneralText.Departure}</div>
                                        <div class="d-flex justify-content-between flex-wrap">
                                            <span class="pb-1"><i class="fa fa-moon-o mr-1"></i> ${endDate.toString("dddd")}</span>
                                            <span class="pb-1"><i class="fa fa-calendar mr-1"></i> ${endDate.toString("d")}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="row cardBtns pt-3">
                                    <div class="col pb-3 pb-sm-0">
                                        <a href="${url}/book/${deal.house.id}?date=${startDate.formatDate("dd-mm-yy")}" class="btn btn-success btn-block text-nowrap pl-0 pr-0" data-command="book" data-bookhusportal="${(url.length > 0 ? "show" : "")}" data-propertyowner="${deal.house.companyName}" data-encrypteddata="${deal.house.encryptedData}" data-redirectto="/book/${deal.house.id}">
                                            ${(window as any).Bookhus.Localization.Standard.UI.ButtonText.Book}
                                        </a>
                                    </div>
                                    <div class="col">
                                        <a href="${url}/house/${deal.house.id}" class="btn btn-primary btn-block text-nowrap pl-0 pr-0" data-bookhusportal="${(url.length > 0 ? "show" : "")}" data-propertyowner="${deal.house.companyName}" data-encrypteddata="${deal.house.encryptedData}" data-redirectto="/house/${deal.house.id}">
                                            ${(window as any).Bookhus.Localization.Standard.UI.ButtonText.Info}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>`);
                $container.append($item);

                if (this.props.validateAllowBooking) {
                    $item.find('[data-command="book"]').on('click', (event) => {
                        event.preventDefault();
                        var link = $(event.target).attr("href");

                        var startdate = new Date(deal.fromdateRfc1123);
                        var enddate = new Date(deal.todateRfc1123);

                        $.getJSON("/api/booking/getbookingposibilities?houseId=" + deal.house.id + "&startdate=" + startdate.formatDate("yy-mm-dd") + "&enddate=" + enddate.formatDate("yy-mm-dd"))
                            .done((posibilities: IBookingposibility[]) => {

                                for (var i = 0; i < posibilities.length; i++) {
                                    if (this.CompareDates(new Date(posibilities[i].arrivaldateRfc1123), startdate) && this.CompareDates(new Date(posibilities[i].departuredateRfc1123), enddate) && posibilities[i].type != 2) {
                                        window.location.href = link;
                                        return true;
                                    }
                                }
                                swal.fire({
                                    html: this.props.validationMessage,
                                    icon: 'info'
                                });
                                return false;
                            });
                    });
                }
            };

            return $container;
        }

        private buildDealControl(): DealControlJQuery {
            var $container = $(`
                <ul class="deal-control pagination justify-content-center mt-4">
                </ul>
            `) as DealControlJQuery;

            $container.renderControls = (totalItems: number) => {
                $container.html('');

                if (this.currentPage > 1) {
                    $container.append(`
                        <li class="page-item">
                          <a class="page-link" href="#" data-page="prev" aria-label="Previous">
                            <span aria-hidden="true">&laquo;</span>
                          </a>
                        </li>
                    `);
                }

                var totalPages = Math.ceil(totalItems / this.props.pageSize);
                if (totalPages > 1) {
                    for (var i = 1; i <= totalPages; i++) {
                        $container.append(`
                            <li class="page-item"><a class="page-link" href="#" data-page="${i}">${i}</a></li>
                        `);
                    }
                }

                if (this.currentPage * this.props.pageSize < totalItems) {
                    $container.append(`
                        <li class="page-item">
                          <a class="page-link" href="#" data-page="next" aria-label="Next">
                            <span aria-hidden="true">&raquo;</span>
                          </a>
                        </li>
                    `);
                }

                $container.off('click').on('click', '[data-page]', (event) => {
                    event.preventDefault();
                    var $target = $(event.currentTarget);

                    var page = $target.data('page');
                    switch (page) {
                        case 'prev':
                            if (this.currentPage > 1) {
                                this.currentPage -= 1;
                                this.search(this.filter);
                            }
                            break;
                        case 'next':
                            if (this.currentPage * this.props.pageSize < totalItems) {
                                this.currentPage += 1;
                                this.search(this.filter);
                            }
                            break;
                        default:
                            var parsedPage = parseInt(page);
                            if (!isNaN(parsedPage)) {
                                this.currentPage = parsedPage;
                                this.search(this.filter);
                            }
                            break;
                    }
                });

            };

            return $container;
        }

        search(filter: ISearchCridentials = null) {
            this.filter = filter;
            if (!this.filter) {
                this.filter = this.setSearchFilter()
            }

            $.ajaxSetup({ cache: false });

            this.loader.displayLoader();

            $.getJSON('/api/deallist/GetWithTotal?pagenumber=' + this.currentPage + '&rowsPerPage=' + this.props.pageSize + '&type=' + this.props.dealType, filter, (result: { totalItems: number, deals: IDeal[] }) => {
                var { totalItems, deals } = result;

                this.loader.hideLoader();
                if (totalItems <= 0) {
                    this.dealList.displayEmptyMessage();
                    return;
                }
                
                this.dealList.emptyList();
                deals.forEach((deal) => {
                    this.dealList.addItem(deal);
                });

                this.dealControl.renderControls(totalItems);
            });
        }

        private setSearchFilter(): ISearchCridentials {
            var search = location.search.substring(1);
            var cridentials = search.length > 0 ? JSON.parse('{"' + decodeURIComponent(search).replace(/&/g, '","').replace(/=/g, '":"') + '"}') : {};
            return cridentials
        }

        private CompareDates(date1: Date, date2: Date): boolean {
            date1.setUTCHours(0, 0, 0, 0);
            date2.setUTCHours(0, 0, 0, 0);
            return date1.getTime() == date2.getTime();
        }

        public static init(target: string, props: IDealListProps): void {
            var extendedProps = $.extend({

            }, props);
            
            $(target).each((index, element) => {
                var $element = $(element);
                if (!$element.data(INSTANCE_NAME)) {
                    $element.data(INSTANCE_NAME, new DealList($element, extendedProps));
                }
            });
        }

        public static getInstance(target: string): DealList {
            return $(target).data(INSTANCE_NAME) as DealList
        }
    }
}